
        require('./index.scss');
        'use strict';

var $ = window.$;
var $mod = $('.module-bottom-ads');

var _module = {
    init: function init() {
        $mod.find('.ad-unit').mouseenter(function () {
            if (!$(this).find('.big-img').attr('src')) {
                $(this).find('.big-img').attr('src', $(this).find('.big-img').data('big'));
            }
        });
    }
};

_module.init();;
    


// WEBPACK FOOTER //
// ./src/module/home-index/header/bottom-ads/index.js